import React, { Component } from 'react';
// import PropTypes from 'prop-types';
import UserRegisterForm from '../components/UserRegister/UserRegisterForm';
import Dashboard from '../components/Menu/Dashboard';
import { makeStyles } from '@material-ui/core/styles';
import UserRegisterStepper from '../components/UserRegister/UserRegisterStepper';
import UserRegisterSecondForm from '../components/UserRegister/UserRegisterSecondForm';
import GenerateRandomCode from 'react-random-code-generator';
import { getCustomerDataByCedule } from "./../actions/balances";
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { createUser } from './../actions/user'


class UserRegisterContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            steps: ['Informacion de usuario', 'Detalles de cuenta'],
            activeStep: 0,
            cedule: '',
            number: '',
            cellphone: '',
            type: 'CLIENTE',
            username: '',
            password: '',
            email: ''
        }
    }
    //functions
    genetrateCode(){
        return GenerateRandomCode.TextCode(8);
    }
    componentDidMount() {
        this.setState({password: this.genetrateCode()})
    }
    
    useStyles = () => makeStyles(theme => ({
        textField: {
          width: 200,
        },
        margin: {
          margin: theme.spacing(1),
        },
      }));
    findCustomer = (value) => {
          this.props.getCustomerDataByCedule(value).then(r => {
                // console.log('mi respuesta  ', r)
                if (r.payload.message) {
                    // throw new SubmissionError(r.payload)
                    this.props.handleOpenSnack('Usuario no encontrado', 'error')
                } else {
                    const {number, Customers } = r.payload.data[0]
                    const { first_name, second_name, surname, second_surname, cedule, email, phone } = Customers
                    let owner = `${first_name} ${second_name} ${surname} ${second_surname}`
                    // console.log('elphone ', phone)
                    this.setState({ owner, cedule, email, number, cellphone: phone })
                }
                // customer = r.payload
            }).catch( error => {
                //console.log('error de consulta ', error)
                this.props.handleOpenSnack('Usuario no encontrado', 'error')
            })
    }
    // handle
    handleSubmit = (values) => {
      const { cedule, number, cellphone, email, type } = values
      const { activeStep } = this.state
      this.setState({activeStep: (activeStep + 1), cedule, number, cellphone, email, type})
      // console.log(values)
    }
    handleSecondSubmit = (values) => {
      const { activeStep, type, cedule, number, email, cellphone } = this.state
      this.setState({activeStep: (activeStep + 1)})
      let dataSend = {
        vusk: cedule,
        number,
        cellphone,
        type,
        mail: email,
        state: 0,
        password: values.password,
        email: values.username
      }
      this.props.createUser(dataSend).then(r => {
        // console.log('respuesta de creacion', r)
      })
      // console.log(values)
    }
    handleBack = (values) => {
      const { activeStep } = this.state
      this.setState({activeStep: (activeStep - 1)})
      // console.log(values)
    }
    //render
    renderUserRegisterForm = () => {
        return <UserRegisterForm
                    {...this.state}
                    classes = { this.useStyles() }
                    findCustomer = { this.findCustomer}
                    onSubmit = { this.handleSubmit }
                    handleBack = { this.handleBack }
                    //  cancelButton = { this.handleCancelTransferForm }
        />
    }
    renderUserRegisterSecondForm = () => {
        return <UserRegisterSecondForm
                    {...this.state}
                    classes = { this.useStyles() }
                    onSubmit = { this.handleSecondSubmit }
                    handleBack = { this.handleBack }
                    //  cancelButton = { this.handleCancelTransferForm }
        />
    }
    renderBody = () => {
        return  <UserRegisterStepper
                        { ...this.state }
                        user = {this.props.user}
                        UserRegisterForm = { this.renderUserRegisterForm() }
                        UserRegisterSecondForm = { this.renderUserRegisterSecondForm() }
                    />
    }
    render() {
        return (
            <div>
                <Dashboard
                    title= ""
                    body = { this.renderBody() }
                    multiple = { false }
                />
            </div>
        );
    }
}

UserRegisterContainer.propTypes = {

};

export default withRouter(connect(null, {createUser, getCustomerDataByCedule} )(UserRegisterContainer))
// export default UserRegisterContainer;